import {createEntitySlice} from 'utils/createEntitySlice';
import {ReferralSource} from 'types/referralSource';
import {ReferralSourceThunks} from 'features/referralSource/referralSourceThunks';

export interface ReferralSourceState {
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
  referralSources?: any;
  pagy?: any;
  referralSource?: any;
  isEditing?: boolean;
  activeTab?: string;
}

const initialState: ReferralSourceState = {
  status: 'idle',
  error: null,
  referralSources: [],
  referralSource: {name: '', agency: ''},
  pagy: {},
  isEditing: false,
};

const referralSourceSlice = createEntitySlice<ReferralSource>({
  name: 'referralSource',
  initialState,
  thunks: ReferralSourceThunks,
  entityKey: 'referralSource',
  entitiesKey: 'referralSources',
  reducers: {},
});

export const {
  setEntity: setReferralSource,
  setIsEditing,
  setActiveTab,
} = referralSourceSlice.actions;
export {initialState as referralSourceInitialState};
export default referralSourceSlice.reducer;
